import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Spritesheet, Texture } from "pixi.js";
export class MarketplaceResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("MarketplaceResourcePackage");
    }
    public get assets_views_marketplace_marketplace_0_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/marketplace/marketplace-0_1x.atlas.json");
    }
    public get assets_views_marketplace_map_f_1_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["map_f_1.png"];
    }
    public get assets_views_marketplace_map_f_2_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["map_f_2.png"];
    }
    public get assets_views_marketplace_news_background_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["news_background.png"];
    }
    public get assets_views_marketplace_sold_bg_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["sold_bg.png"];
    }
    public get assets_views_marketplace_zip_zones_4_selectedglow_10032_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["zip_zones_4/selectedglow/10032.png"];
    }
    public get assets_views_marketplace_nft_card_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["nft_card.png"];
    }
    public get assets_views_marketplace_zip_zones_2_selectedglow_10018_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["zip_zones_2/selectedglow/10018.png"];
    }
    public get assets_views_marketplace_nftloaderbg_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["nftloaderbg.png"];
    }
    public get assets_views_marketplace_road_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["road.png"];
    }
    public get assets_views_marketplace_zip_zones_3_corners_10028_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["zip_zones_3/corners/10028.png"];
    }
    public get assets_views_marketplace_NFT_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["NFT.png"];
    }
    public get assets_views_marketplace_zip_zones_4_corners_10040_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["zip_zones_4/corners/10040.png"];
    }
    public get assets_views_marketplace_sold_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["sold.png"];
    }
    public get assets_views_marketplace_zip_zones_2_corners_10065_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["zip_zones_2/corners/10065.png"];
    }
    public get assets_views_marketplace_zip_zones_3_corners_10075_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["zip_zones_3/corners/10075.png"];
    }
    public get assets_views_marketplace_zip_zones_1_corners_10007_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["zip_zones_1/corners/10007.png"];
    }
    public get assets_views_marketplace_zip_zones_3_corners_10026_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["zip_zones_3/corners/10026.png"];
    }
    public get assets_views_marketplace_zip_zones_1_corners_10038_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["zip_zones_1/corners/10038.png"];
    }
    public get assets_views_marketplace_zip_zones_4_corners_10030_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["zip_zones_4/corners/10030.png"];
    }
    public get assets_views_marketplace_mon_glow_icon_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["mon/glow_icon.png"];
    }
    public get assets_views_marketplace_zip_zones_1_corners_10004_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["zip_zones_1/corners/10004.png"];
    }
    public get assets_views_marketplace_label_frame_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["label_frame.png"];
    }
    public get assets_views_marketplace_pins_green_pin_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["pins/green_pin.png"];
    }
    public get assets_views_marketplace_pins_orange_pin_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["pins/orange_pin.png"];
    }
    public get assets_views_marketplace_zip_zones_1_corners_10282_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["zip_zones_1/corners/10282.png"];
    }
    public get assets_views_marketplace_check_box_swith_on_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["check_box/swith_on.png"];
    }
    public get assets_views_marketplace_check_box_switch_off_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["check_box/switch_off.png"];
    }
    public get assets_views_marketplace_Price_history_icon_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["Price_history_icon.png"];
    }
    public get assets_views_marketplace_zip_zones_2_corners_10020_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["zip_zones_2/corners/10020.png"];
    }
    public get assets_views_marketplace_avatar_glow_marketplace_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["avatar_glow_marketplace.png"];
    }
    public get assets_views_marketplace_mon_icon_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["mon/icon.png"];
    }
    public get assets_views_marketplace_piggy_icon_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["piggy_icon.png"];
    }
    public get assets_views_marketplace_token_icon_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["token_icon.png"];
    }
    public get assets_views_marketplace_x_cross_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["x_cross.png"];
    }
    public get assets_views_marketplace_check_box_pointer_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["check_box/pointer.png"];
    }
    public get assets_views_marketplace_I_png(): Texture {
        return this.assets_views_marketplace_marketplace_0_1x_atlas_json.textures["I.png"];
    }
    public get assets_views_marketplace_marketplace_0_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/marketplace/marketplace-0_1x.atlas.png");
    }
    public get assets_views_marketplace_marketplace_1_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/marketplace/marketplace-1_1x.atlas.json");
    }
    public get assets_views_marketplace_map_f_3_png(): Texture {
        return this.assets_views_marketplace_marketplace_1_1x_atlas_json.textures["map_f_3.png"];
    }
    public get assets_views_marketplace_map_f_4_png(): Texture {
        return this.assets_views_marketplace_marketplace_1_1x_atlas_json.textures["map_f_4.png"];
    }
    public get assets_views_marketplace_zip_zones_4_selectedglow_10035_png(): Texture {
        return this.assets_views_marketplace_marketplace_1_1x_atlas_json.textures["zip_zones_4/selectedglow/10035.png"];
    }
    public get assets_views_marketplace_zip_zones_1_selectedglow_10002_png(): Texture {
        return this.assets_views_marketplace_marketplace_1_1x_atlas_json.textures["zip_zones_1/selectedglow/10002.png"];
    }
    public get assets_views_marketplace_zip_zones_3_corners_10000_png(): Texture {
        return this.assets_views_marketplace_marketplace_1_1x_atlas_json.textures["zip_zones_3/corners/10000.png"];
    }
    public get assets_views_marketplace_zip_zones_1_selectedglow_10011_png(): Texture {
        return this.assets_views_marketplace_marketplace_1_1x_atlas_json.textures["zip_zones_1/selectedglow/10011.png"];
    }
    public get assets_views_marketplace_zip_zones_1_corners_10002_png(): Texture {
        return this.assets_views_marketplace_marketplace_1_1x_atlas_json.textures["zip_zones_1/corners/10002.png"];
    }
    public get assets_views_marketplace_zip_zones_3_selectedglow_10128_png(): Texture {
        return this.assets_views_marketplace_marketplace_1_1x_atlas_json.textures["zip_zones_3/selectedglow/10128.png"];
    }
    public get assets_views_marketplace_zip_zone_1_png(): Texture {
        return this.assets_views_marketplace_marketplace_1_1x_atlas_json.textures["zip_zone_1.png"];
    }
    public get assets_views_marketplace_zip_zone_4_png(): Texture {
        return this.assets_views_marketplace_marketplace_1_1x_atlas_json.textures["zip_zone_4.png"];
    }
    public get assets_views_marketplace_zip_zones_3_selectedglow_10024_png(): Texture {
        return this.assets_views_marketplace_marketplace_1_1x_atlas_json.textures["zip_zones_3/selectedglow/10024.png"];
    }
    public get assets_views_marketplace_zip_zones_4_corners_10027_png(): Texture {
        return this.assets_views_marketplace_marketplace_1_1x_atlas_json.textures["zip_zones_4/corners/10027.png"];
    }
    public get assets_views_marketplace_marketplace_1_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/marketplace/marketplace-1_1x.atlas.png");
    }
    public get assets_views_marketplace_marketplace_2_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/marketplace/marketplace-2_1x.atlas.json");
    }
    public get assets_views_marketplace_map_f_all_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["map_f_all.png"];
    }
    public get assets_views_marketplace_fullbuilding_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["fullbuilding.png"];
    }
    public get assets_views_marketplace_zip_zones_3_selectedglow_10000_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["zip_zones_3/selectedglow/10000.png"];
    }
    public get assets_views_marketplace_zip_zones_2_selectedglow_10066_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["zip_zones_2/selectedglow/10066.png"];
    }
    public get assets_views_marketplace_zip_zones_3_selectedglow_10044_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["zip_zones_3/selectedglow/10044.png"];
    }
    public get assets_views_marketplace_zone_2_white_line_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["zone_2_white_line.png"];
    }
    public get assets_views_marketplace_zip_zones_1_selectedglow_10003_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["zip_zones_1/selectedglow/10003.png"];
    }
    public get assets_views_marketplace_zip_zones_3_corners_10029_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["zip_zones_3/corners/10029.png"];
    }
    public get assets_views_marketplace_zip_zones_2_corners_10018_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["zip_zones_2/corners/10018.png"];
    }
    public get assets_views_marketplace_zip_zones_4_corners_10033_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["zip_zones_4/corners/10033.png"];
    }
    public get assets_views_marketplace_zip_zones_4_corners_10039_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["zip_zones_4/corners/10039.png"];
    }
    public get assets_views_marketplace_zip_zones_4_corners_10037_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["zip_zones_4/corners/10037.png"];
    }
    public get assets_views_marketplace_zip_zones_1_corners_10280_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["zip_zones_1/corners/10280.png"];
    }
    public get assets_views_marketplace_discount_coupons_glow_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["discount_coupons_glow.png"];
    }
    public get assets_views_marketplace_zip_zones_1_corners_10005_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["zip_zones_1/corners/10005.png"];
    }
    public get assets_views_marketplace_zip_zones_1_corners_10006_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["zip_zones_1/corners/10006.png"];
    }
    public get assets_views_marketplace_swith_button_bg_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["swith_button_bg.png"];
    }
    public get assets_views_marketplace_zoom_button_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["zoom_button.png"];
    }
    public get assets_views_marketplace_loader_png(): Texture {
        return this.assets_views_marketplace_marketplace_2_1x_atlas_json.textures["loader.png"];
    }
    public get assets_views_marketplace_marketplace_2_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/marketplace/marketplace-2_1x.atlas.png");
    }
    public get assets_views_marketplace_marketplace_3_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/marketplace/marketplace-3_1x.atlas.json");
    }
    public get assets_views_marketplace_map_base_line_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["map_base_line.png"];
    }
    public get assets_views_marketplace_glow_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["glow.png"];
    }
    public get assets_views_marketplace_zone_4_white_line_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zone_4_white_line.png"];
    }
    public get assets_views_marketplace_zone_3_white_line_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zone_3_white_line.png"];
    }
    public get assets_views_marketplace_zip_zones_4_corners_10035_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_4/corners/10035.png"];
    }
    public get assets_views_marketplace_zip_zones_3_selectedglow_10029_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_3/selectedglow/10029.png"];
    }
    public get assets_views_marketplace_zip_zones_4_selectedglow_10027_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_4/selectedglow/10027.png"];
    }
    public get assets_views_marketplace_zone_1_white_line_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zone_1_white_line.png"];
    }
    public get assets_views_marketplace_zip_zones_4_selectedglow_10034_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_4/selectedglow/10034.png"];
    }
    public get assets_views_marketplace_zip_zones_2_selectedglow_10036_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_2/selectedglow/10036.png"];
    }
    public get assets_views_marketplace_zip_zones_3_selectedglow_10028_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_3/selectedglow/10028.png"];
    }
    public get assets_views_marketplace_zip_zones_2_selectedglow_10001_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_2/selectedglow/10001.png"];
    }
    public get assets_views_marketplace_Button_green_long_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["Button_green_long.png"];
    }
    public get assets_views_marketplace_Button_red_long_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["Button_red_long.png"];
    }
    public get assets_views_marketplace_zip_zones_2_corners_10066_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_2/corners/10066.png"];
    }
    public get assets_views_marketplace_zip_zones_4_corners_10032_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_4/corners/10032.png"];
    }
    public get assets_views_marketplace_zip_zones_4_corners_10034_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_4/corners/10034.png"];
    }
    public get assets_views_marketplace_zip_zones_1_selectedglow_10014_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_1/selectedglow/10014.png"];
    }
    public get assets_views_marketplace_zip_zones_3_selectedglow_10026_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_3/selectedglow/10026.png"];
    }
    public get assets_views_marketplace_zip_zone_3_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zone_3.png"];
    }
    public get assets_views_marketplace_zip_zones_2_corners_10001_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_2/corners/10001.png"];
    }
    public get assets_views_marketplace_zip_zones_3_corners_10044_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_3/corners/10044.png"];
    }
    public get assets_views_marketplace_zip_zones_2_selectedglow_10065_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_2/selectedglow/10065.png"];
    }
    public get assets_views_marketplace_zip_zones_1_selectedglow_10038_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_1/selectedglow/10038.png"];
    }
    public get assets_views_marketplace_zip_zones_2_corners_10036_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_2/corners/10036.png"];
    }
    public get assets_views_marketplace_zip_zones_4_selectedglow_10030_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_4/selectedglow/10030.png"];
    }
    public get assets_views_marketplace_zip_zones_4_selectedglow_10039_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_4/selectedglow/10039.png"];
    }
    public get assets_views_marketplace_zip_zones_3_corners_10021_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_3/corners/10021.png"];
    }
    public get assets_views_marketplace_zip_zones_2_corners_10023_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_2/corners/10023.png"];
    }
    public get assets_views_marketplace_zip_zones_2_corners_10022_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_2/corners/10022.png"];
    }
    public get assets_views_marketplace_zip_zones_4_corners_10031_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_4/corners/10031.png"];
    }
    public get assets_views_marketplace_zip_zones_2_corners_10017_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_2/corners/10017.png"];
    }
    public get assets_views_marketplace_zip_zones_2_corners_10016_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_2/corners/10016.png"];
    }
    public get assets_views_marketplace_zip_zones_3_corners_10024_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_3/corners/10024.png"];
    }
    public get assets_views_marketplace_zip_zones_4_corners_10035_1_png(): Texture {
        return this.assets_views_marketplace_marketplace_3_1x_atlas_json.textures["zip_zones_4/corners/10035-1.png"];
    }
    public get assets_views_marketplace_marketplace_3_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/marketplace/marketplace-3_1x.atlas.png");
    }
    public get assets_views_marketplace_marketplace_4_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/marketplace/marketplace-4_1x.atlas.json");
    }
    public get assets_views_marketplace_zip_zones_4_selectedglow_10040_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_4/selectedglow/10040.png"];
    }
    public get assets_views_marketplace_zip_zones_1_selectedglow_10013_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_1/selectedglow/10013.png"];
    }
    public get assets_views_marketplace_zip_zones_3_selectedglow_10021_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_3/selectedglow/10021.png"];
    }
    public get assets_views_marketplace_zip_zones_3_selectedglow_10025_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_3/selectedglow/10025.png"];
    }
    public get assets_views_marketplace_zip_zones_2_selectedglow_10022_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_2/selectedglow/10022.png"];
    }
    public get assets_views_marketplace_zip_zones_2_selectedglow_10023_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_2/selectedglow/10023.png"];
    }
    public get assets_views_marketplace_zip_zones_4_selectedglow_10031_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_4/selectedglow/10031.png"];
    }
    public get assets_views_marketplace_zip_zones_4_selectedglow_10033_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_4/selectedglow/10033.png"];
    }
    public get assets_views_marketplace_zip_zones_2_selectedglow_10017_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_2/selectedglow/10017.png"];
    }
    public get assets_views_marketplace_zip_zones_2_selectedglow_10016_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_2/selectedglow/10016.png"];
    }
    public get assets_views_marketplace_zip_zones_3_selectedglow_10075_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_3/selectedglow/10075.png"];
    }
    public get assets_views_marketplace_zip_zone_2_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zone_2.png"];
    }
    public get assets_views_marketplace_zip_zones_2_selectedglow_10010_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_2/selectedglow/10010.png"];
    }
    public get assets_views_marketplace_zip_zones_1_selectedglow_10007_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_1/selectedglow/10007.png"];
    }
    public get assets_views_marketplace_zip_zones_1_selectedglow_10012_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_1/selectedglow/10012.png"];
    }
    public get assets_views_marketplace_zip_zones_1_selectedglow_10009_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_1/selectedglow/10009.png"];
    }
    public get assets_views_marketplace_zip_zones_1_corners_10013_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_1/corners/10013.png"];
    }
    public get assets_views_marketplace_zip_zones_4_selectedglow_10037_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_4/selectedglow/10037.png"];
    }
    public get assets_views_marketplace_zip_zones_1_corners_10009_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_1/corners/10009.png"];
    }
    public get assets_views_marketplace_zip_zones_3_corners_10025_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_3/corners/10025.png"];
    }
    public get assets_views_marketplace_zip_zones_1_corners_10003_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_1/corners/10003.png"];
    }
    public get assets_views_marketplace_zip_zones_1_selectedglow_10005_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_1/selectedglow/10005.png"];
    }
    public get assets_views_marketplace_zip_zones_1_selectedglow_10280_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_1/selectedglow/10280.png"];
    }
    public get assets_views_marketplace_zip_zones_1_selectedglow_10004_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_1/selectedglow/10004.png"];
    }
    public get assets_views_marketplace_zip_zones_1_corners_10011_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_1/corners/10011.png"];
    }
    public get assets_views_marketplace_zip_zones_1_selectedglow_10006_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_1/selectedglow/10006.png"];
    }
    public get assets_views_marketplace_zip_zones_3_corners_10128_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_3/corners/10128.png"];
    }
    public get assets_views_marketplace_zip_zones_2_corners_10010_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_2/corners/10010.png"];
    }
    public get assets_views_marketplace_zip_zones_1_selectedglow_10282_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_1/selectedglow/10282.png"];
    }
    public get assets_views_marketplace_zip_zones_1_corners_10012_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_1/corners/10012.png"];
    }
    public get assets_views_marketplace_zip_zones_1_corners_10014_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_1/corners/10014.png"];
    }
    public get assets_views_marketplace_zip_zones_2_selectedglow_10020_png(): Texture {
        return this.assets_views_marketplace_marketplace_4_1x_atlas_json.textures["zip_zones_2/selectedglow/10020.png"];
    }
    public get assets_views_marketplace_marketplace_4_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/marketplace/marketplace-4_1x.atlas.png");
    }
}

